import { useParams } from "react-router-dom";
import pageData from "../content/pages.json";
import Hero from "../components/features/Hero";
import OverView from "../components/features/OverView";
import WhyChoose from "../components/features/WhyChoose";
import Info from "../components/features/Info";
import ManagementAccordion from "../components/features/ManagementAccordion";

const Features = () => {
  const { slug } = useParams();
  const page = pageData.find((item) => item.slug === slug);

  if (!page) {
    return <div className="p-6 text-red-600">Page not found</div>;
  }

  return (
    <div className="">
        <Hero data={page.hero}/>
        <OverView data={page.overView}/>
        <WhyChoose data={page.requestFeature}/>
        <ManagementAccordion accordionData={page.managmentData}/>
        <Info data={page.info}/>
    </div>
  );
};

export default Features;
